/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useAuth } from "../context/auth/AuthContext";

const normalizePermission = (value) => value === 1 || value === true;

const EMPTY_PERMISSIONS = {
  viewAdminDashboard: false,
  viewAdminStores: false,
  addAdminStore: false,
  editAdminStore: false,
  deleteAdminStore: false,
  viewAdminPayments: false,
  viewAdminPlansSubscriptions: false,
  viewAdminReportsRevenues: false,
  viewAdminReportsPlans: false,
  viewAdminReportsGrowth: false,
  viewAdminReportsPayments: false,
  viewAdminNotifications: false,
  viewAdminShipping: false,
  viewAdminPlansPage: false,
  addAdminPlan: false,
  editAdminPlan: false,
  deleteAdminPlan: false,
  viewAdminEmployees: false,
  addAdminEmployee: false,
  editAdminEmployee: false,
  deleteAdminEmployee: false,
};

export const useSuperAdminPermissions = () => {
  const { authRole, permissions, isSuperAdmin } = useAuth();

  if (!isSuperAdmin() || authRole !== "superAdmin") {
    return EMPTY_PERMISSIONS;
  }

  return {
    viewAdminDashboard: normalizePermission(permissions.viewAdminDashboard),
    viewAdminStores: normalizePermission(permissions.viewAdminStores),
    addAdminStore: normalizePermission(permissions.addAdminStore),
    editAdminStore: normalizePermission(permissions.editAdminStore),
    deleteAdminStore: normalizePermission(permissions.deleteAdminStore),
    viewAdminPayments: normalizePermission(permissions.viewAdminPayments),
    viewAdminPlansSubscriptions: normalizePermission(permissions.viewAdminPlansSubscriptions),
    viewAdminReportsRevenues: normalizePermission(permissions.viewAdminReportsRevenues),
    viewAdminReportsPlans: normalizePermission(permissions.viewAdminReportsPlans),
    viewAdminReportsGrowth: normalizePermission(permissions.viewAdminReportsGrowth),
    viewAdminReportsPayments: normalizePermission(permissions.viewAdminReportsPayments),
    viewAdminNotifications: normalizePermission(permissions.viewAdminNotifications),
    viewAdminShipping: normalizePermission(permissions.viewAdminShipping),
    viewAdminPlansPage: normalizePermission(permissions.viewAdminPlansPage),
    addAdminPlan: normalizePermission(permissions.addAdminPlan),
    editAdminPlan: normalizePermission(permissions.editAdminPlan),
    deleteAdminPlan: normalizePermission(permissions.deleteAdminPlan),
    viewAdminEmployees: normalizePermission(permissions.viewAdminEmployees),
    addAdminEmployee: normalizePermission(permissions.addAdminEmployee),
    editAdminEmployee: normalizePermission(permissions.editAdminEmployee),
    deleteAdminEmployee: normalizePermission(permissions.deleteAdminEmployee),
  };
};
